<template>
  <section>
    <b-select
      expanded
      v-model="$store.state.liberatorError"
      @input="updateMessageError()"
      v-show="false"
    />
    <b-select
      expanded
      v-model="$store.state.liberatorSuccess"
      @input="updateMessageSuccess()"
      v-show="false"
    />
  </section>
</template>

<script>
export default {
  methods: {
    updateMessageError() {
      console.log("updateMessageError()", this.$store.state.liberatorError);
      if (
        this.$store.state.liberatorError &&
        this.$store.state.liberatorError != ""
      )
        this.showError(this.$store.state.liberatorError);
    },
    updateMessageSuccess() {
      console.log("updateMessageSuccess()", this.$store.state.liberatorSuccess);
      if (
        this.$store.state.liberatorSuccess &&
        this.$store.state.liberatorSuccess != ""
      )
        this.showSuccess(this.$store.state.liberatorSuccess);
    }
  }
};
</script>

<style>
</style>
